<script lang="ts" setup>
import { Link } from "@inertiajs/vue3";

const props = defineProps<{
    raw?: boolean;
    text?: string;
}>();
</script>

<template>
    <component
        :is="$attrs.href && raw ? 'a' : $attrs.href ? Link : 'span'"
        class="link w-fit border-b-2 pb-px font-medium tracking-wide hover:cursor-pointer"
    >
        <slot v-if="$slots.default" />
        <template v-else-if="text">{{ text }}</template>
    </component>
</template>

<style scoped>
.link {
    border-image: linear-gradient(to right, #6ee7b7, #fcd34d) 1;
}
</style>
